import type { NavBadge } from '@/shell/module-system'
import { useWaitingForMe } from './api/onboarding-queries'

/** Sidebar count: requests at this person's sign-off step, or their returned drafts (Chris 2026-10-09). */
export function useProductsNavBadge(): NavBadge | null {
  const { data } = useWaitingForMe()
  return data?.count ? { count: data.count, tone: 'warning', title: `${data.count} waiting for you` } : null
}
